export var roleClearStateList = [{
  id: 0,
  label: "全部"
}, {
  id: 1,
  label: "待审批"
}, {
  id: 2,
  label: "审批驳回"
}, {
  id: 3,
  label: "审批通过"
}];